export default __webpack_public_path__ + "static/monday-apps-0fe274f90d83e2284cbbee04b5a13913.svg";